import React from 'react';
import styled from 'styled-components';
import { theme } from 'utils/style/theme';
import CircleLoader from 'components/Loader/CircleLoader';

interface IProps {
  text: string;
  height: string;
  width: string;
  bgColor: string;
  textColor: string;
  fontWeight: string;
  fontSize: string;
  border: string;
  rounded: string;
  hoverBgColor: string;
  activeBgColor: string;
  selectedBgColor: string;
  onClick?: (e: any) => void;
  disabled?: boolean;
  loading?: boolean;
  loadingColor?: string;
  selected?: boolean;
  LeftPlaceHolder?: JSX.Element;
  RightPlaceHolder?: JSX.Element;
  cursorPointer?: boolean;
}

const PrimaryButton: React.FC<IProps> = ({
  text,
  height = 'auto',
  width = 'fit-content',
  bgColor,
  textColor,
  hoverBgColor,
  activeBgColor,
  selectedBgColor,
  fontWeight,
  fontSize,
  border,
  rounded,
  onClick = () => {
    return;
  },
  loading = false,
  loadingColor = 'white',
  disabled = false,
  selected = false,
  LeftPlaceHolder,
  RightPlaceHolder,
  cursorPointer = true,
}) => {
  return (
    <ButtonWrapper
      width={width}
      height={height}
      bgColor={bgColor}
      hoverBgColor={hoverBgColor}
      activeBgColor={activeBgColor}
      selectedBgColor={selectedBgColor}
      textColor={textColor}
      fontWeight={fontWeight}
      fontSize={fontSize}
      border={border}
      rounded={rounded}
      onClick={onClick}
      selected={selected}
      disabled={disabled}
      cursorPointer={cursorPointer}
    >
      {loading && <CircleLoader color={loadingColor} />}

      {LeftPlaceHolder && LeftPlaceHolder}
      <p>{text}</p>
      {RightPlaceHolder && RightPlaceHolder}
    </ButtonWrapper>
  );
};

export default PrimaryButton;

const ButtonWrapper = styled.div.attrs(
  (props: {
    bgColor: string;
    textColor: string;
    hoverBgColor: string;
    activeBgColor: string;
    selectedBgColor: string;
    width: string;
    height: string;
    fontWeight: string;
    fontSize: string;
    border: string;
    rounded: string;
    selected: boolean;
    disabled: boolean;
    cursorPointer: boolean;
  }) => props,
)`
  height: ${(props) => props.height};
  width: ${(props) => props.width};
  background-color: ${(props) =>
    props.selected ? props.selectedBgColor : props.bgColor};
  color: ${(props) => props.textColor};
  font-size: ${(props) => props.fontSize};
  font-weight: ${(props) => props.fontWeight};
  border: ${(props) => props.border};
  border-radius: ${(props) => props.rounded};
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: ${(props) => (props.cursorPointer ? 'pointer' : 'default')};
  padding: 8px 16px;
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
  filter: ${(props) => (props.disabled ? 'opacity(0.5)' : 'none')};
  & > * + * {
    margin-left: 1rem;
  }

  &:hover {
    background-color: ${(props) => props.hoverBgColor};
  }
  &:active {
    background-color: ${(props) => props.activeBgColor};
  }
  &:focus {
    border: 3px solid ${theme.colors.blue_focus};
  }
`;
